import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../hooks/hooks';
import { resetClassroomTypeData } from '../../redux/slices/school/classroomType';
import { RootState } from '../../redux/store';
import { routes } from '../../routes';
import { updateClassRoomType } from '../../services/school/classroom/classroom';
import { ClassroomTypesType } from '../../types/Classroom';
import { Key_classroomtypes } from '../../utils/constants';
import { CreateClassroomTypeFormValidation } from './CreateClassroomTypeFormValidation';

export const UpdateClassroomTypes = ()=> {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const mutation = useMutation({ mutationFn: updateClassRoomType, mutationKey: "updateClassRoomType" })
  const classroomTypeFormData = useSelector((state: RootState) => state.classroomType);
  const queryClient = useQueryClient();

  const { control, handleSubmit, formState: { errors }, reset } = useForm<ClassroomTypesType>({
    resolver: yupResolver(CreateClassroomTypeFormValidation),
    defaultValues: classroomTypeFormData,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  })
  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success('Tipo de sala atualizada!');
        queryClient.invalidateQueries(Key_classroomtypes);
        navigate(routes.classroomTypes);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = (e: any) => {
    dispatch(resetClassroomTypeData());
    navigate(routes.classroomTypes);
  }

  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="description" label="Tipo de sala" control={control} errors={errors} fieldProps={{ placeholder: 'Tipo de sala' }} required={true}/>

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}